import { Component, input } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'sanofi-go-to-make-payment-page-button',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './go-to-make-payment-page-button.component.html'
})
export class GoToMakePaymentPageButtonComponent {
  translation = input.required<string>();
}
